{
    "apiUrlfood": "https://162.55.25.226:5000/api/GetFoodbyEvent",
    "apiUrlfoodType":"https://162.55.25.226:5000/api/GetFoodTypebyEvent",
    "apiUrlOTP": "https://spicetrail.co.in/sms-app/send-sms"
}